import React from 'react';
import fLogo from '../../Assets/Images/NEXI_RGB.jpg';
import '../../App.css';
import { NEXI_LOGO_HREF_URL, FOOTER_NEXI_GROUP_HREF_URL, FOOTER_PRIVACY_POLICY_HREF_URL, FOOTER_LEGAL_NOTICE_HREF_URL, FOOTER_COOKIES_HREF_URL } from '../../Config/AppConfiguration';

// Footer with thin, left-aligned layout and correct link names
const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-inner-align">
          {/* Logo row */}
          <div className="footer-logo-row">
            <a href={NEXI_LOGO_HREF_URL} target="_blank" rel="noopener noreferrer">
              <img width={92} src={fLogo} alt="Nexi Logotype" />
            </a>
          </div>
          {/* Links row */}
          <nav className="footer-links-row">
            <a href={FOOTER_NEXI_GROUP_HREF_URL} target="_blank" rel="noopener noreferrer">NEXI GROUP</a>
            <a href={FOOTER_PRIVACY_POLICY_HREF_URL} target="_blank" rel="noopener noreferrer">PRIVACY POLICY</a>
            <a href={FOOTER_LEGAL_NOTICE_HREF_URL} target="_blank" rel="noopener noreferrer">LEGAL NOTICE</a>
            <a href={FOOTER_COOKIES_HREF_URL} target="_blank" rel="noopener noreferrer">COOKIES</a>
          </nav>
          {/* Copyright */}
          <div className="copyright-text">
            © Nexi S.p.A. 2021-2025. All Rights Reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;